<template>
    <b-container fluid class="mt--7">
        <b-card title="Task Types">
            <b-card-body>
                <b-form>
                    <b-form-group
                        id="fieldset-measureable"
                        label="Measureable Item Types"
                        label-for="input-measureable"
                    >
                        <multiselect
                            id="input-measureable"
                            v-model="measurableTypesOptions"
                            :multiple="true"
                            :options="items"
                            label="name"
                            track-by="id"
                            :close-on-select="false"
                        >
                        </multiselect>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-checkable"
                        label="Checkable Item Types"
                        label-for="input-checkable"
                    >
                        <multiselect
                            id="input-checkable"
                            v-model="checkableTypesOptions"
                            :multiple="true"
                            :options="items"
                            label="name"
                            track-by="id"
                            :close-on-select="false"
                        >
                        </multiselect>
                    </b-form-group>

                    <b-button variant="primary" @click="updateTypes" size="sm">
                        <b-spinner
                            small
                            v-if="updating"
                            label="Loading..."
                        ></b-spinner>
                        <span v-else>Update</span>
                    </b-button>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import Multiselect from 'vue-multiselect'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'taskTypeValue',
    mixins: [popupMixins, permissionsMixins],
    components: { Multiselect },
    data: () => ({
        formData: {
            measurableTypes: [],
            checkableTypes: [],
        },
        updating: false,
    }),

    filters: {
        filterOptions(items) {
            return items.map(({ id: value, name: text }) => ({ value, text }))
        },
    },

    computed: {
        //checkableTypes
        checkableTypesOptions: {
            get() {
                const {
                    items,
                    formData: { checkableTypes },
                } = this
                return checkableTypes.map(id =>
                    items.find(item => item.id == id)
                )
            },
            set(selectedItems) {
                this.$set(
                    this.formData,
                    'checkableTypes',
                    selectedItems.map(x => x.id)
                )
            },
        },

        measurableTypesOptions: {
            get() {
                const {
                    items,
                    formData: { measurableTypes },
                } = this
                return measurableTypes.map(id =>
                    items.find(item => item.id == id)
                )
            },
            set(selectedItems) {
                this.$set(
                    this.formData,
                    'measurableTypes',
                    selectedItems.map(x => x.id)
                )
            },
        },

        taskTypeValue() {
            const taskTypeValue = this.$store.getters['company/taskTypeValue']
            console.log('computed taskTypeValue', taskTypeValue)
            return taskTypeValue
        },

        taskTypeKey() {
            return this.$store.state.company.settingKeys.taskTypeKey
        },

        items() {
            const items = this.$store.state.itemType.items
            console.log('items', items)
            return items.map(x => {
                x.is_task = !!x.is_task
                x.is_order_item = !!x.is_order_item
                //x.is_asset = !!x.is_asset
                x.is_discount = !!x.is_discount
                return x
            })
        },
    },

    watch: {
        taskTypeValue: {
            handler: function (val) {
                console.log('watch taskTypeValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.taskTypeKey
        )
        this.$nextTick(() => {
            this.updateModel(this.taskTypeValue)
        })
    },

    methods: {
        updateModel(taskTypeValue) {
            const value = { ...(taskTypeValue || {}) }
            this.$set(
                this.formData,
                'measurableTypes',
                value.measurableTypes || []
            )
            this.$set(
                this.formData,
                'checkableTypes',
                value.checkableTypes || []
            )
        },
        async updateTypes() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false

                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.taskTypeKey,
                    text_value,
                    bool_value,
                })
                this.doToast('Success!', 'Settings Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
